import { saharaEndpoints } from './sahara.endpoints';
import { libraryEndpoints } from './library.endpoints';
import { solarEndpoints } from './solar.endpoints';
import { voucherEndpoints } from './voucher.endpoints';
import { supportEndpoints } from './support.endpoints';
import { agoraEndpoints } from './agora.endpoints';
import { organizationEndpoints } from './organization.endpoints';
import { umeEndpoints } from './ume.endpoints';
import { lunarEndpoints } from './lunar.endpoints';
import { paymentEndpoints } from './payment.endpoints';
import { tmEndpoints } from './tm.endpoints';
import { amberEndpoints } from './amber.endpoints';
import { sphinxEndpoints } from './sphinx.endpoints';
import { transactionEndpoints } from './transaction.endpoints';
import { reviewEndpoints } from './review.endpoints';
import { hamletEndpoints } from './hamlet.endpoints';
import { instructorBookingEndpoints } from './instr-booking.endpoints';
import { phoenix2Endpoints } from './phoenix2.endpoints';
import { notificationManagementEndpoints } from './notification-management.endpoints';
import { productSellerEndpoints } from './product-seller.endpoints';
import { promotionEndpoints } from './promotion.endpoints';
import { odysseyEndpoints } from './odyssey.endpoints';
import { umbrellaEndpoints } from './umbrella.endpoints';


export const endpoints = {
    sahara: saharaEndpoints,
    library: libraryEndpoints,
    solar: solarEndpoints,
    voucher: voucherEndpoints,
    support: supportEndpoints,
    agora: agoraEndpoints,
    odyssey: odysseyEndpoints,
    organization: organizationEndpoints,
    ume: umeEndpoints,
    lunar: lunarEndpoints,
    payment: paymentEndpoints,
    tm: tmEndpoints,
    amber: amberEndpoints,
    sphinx: sphinxEndpoints,
    transaction: transactionEndpoints,
    review: reviewEndpoints,
    hamlet: hamletEndpoints,
    instrBooking: instructorBookingEndpoints,
    phoenix2: phoenix2Endpoints,
    notificationManagement: notificationManagementEndpoints,
    productSeller: productSellerEndpoints,
    promotion: promotionEndpoints,
    umbrella: umbrellaEndpoints
};



// WEBPACK FOOTER //
// ./src/endpoints/endpoints.ts